import { useCallback } from 'react'

import { Select } from 'govwell-ui'
import { SelectOption } from 'govwell-ui/components/Select/types'
import { DelayType } from 'types/graphql'

const options: SelectOption<DelayType>[] = [
  {
    value: 'Minute',
    label: 'minutes',
  },
  {
    value: 'Hour',
    label: 'hours',
  },
  {
    value: 'Day',
    label: 'days',
  },
  {
    value: 'Week',
    label: 'weeks',
  },
  {
    value: 'Month',
    label: 'months',
  },
  {
    value: 'Year',
    label: 'years',
  },
]

type Props = {
  isDisabled?: boolean
  isInvalid?: boolean
  onValueChange: (value: DelayType | undefined) => void
  value: DelayType | null | undefined
  width?: React.CSSProperties['width']
}
export const TimeUnitSelect = ({ isDisabled, isInvalid, onValueChange, value, width }: Props) => {
  const handleSelectedOptionChange = useCallback(
    (option?: SelectOption<DelayType>) => {
      onValueChange(option?.value)
    },
    [onValueChange]
  )

  return (
    <Select
      ariaLabel="Unit of time"
      getOptionKey={(o) => o.value}
      isDisabled={isDisabled}
      isInvalid={isInvalid}
      onSelectedOptionChange={handleSelectedOptionChange}
      options={options}
      placeholder="e.g. days"
      selectedOption={options.find((o) => o.value === value)}
      width={width}
    />
  )
}
